import React, { useState } from 'react'
import { View } from 'react-native'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

import { Header } from '../Header'
import { Footer } from '../Footer'
import { BtText, BtSidebar } from '@linqpal/components/src/ui'
import { ProjectAddRemoveTable } from '../../../Components/ProjectAddRemoveTable'

import { styles } from './styles'

import projectsStore from '../../../../Store'

type SidebarProps = {
  visibleSidebar?: boolean
  setVisibleSidebar: () => void
  chosen: any
  setChosen: any
  setVisibleModal: any
  visibleEdit: boolean
  setVisibleEdit: (a: boolean) => void
  projectId: string
  data: any
  navigation: any
}

export const AddNewProjectSidebar = observer(
  ({
    chosen,
    setChosen,
    projectId,
    setVisibleEdit,
    setVisibleSidebar,
  }: SidebarProps) => {
    const { t } = useTranslation('global')

    const {
      addInvoicesToProject,
      updateSelectedInvoices,
      isVisibleSidebar,
      resetRefresher,
    } = projectsStore

    const [loading, setLoading] = useState(false)

    const handleSuccess = () => {
      setVisibleSidebar()
      setVisibleEdit(false)
      setLoading(false)
      setChosen(null)
      resetRefresher()
    }

    const handleClose = () => {
      updateSelectedInvoices({ selectedRows: [] })
      setVisibleSidebar()
      setVisibleEdit(false)
      setChosen(null)
      return null
    }

    return (
      <BtSidebar
        visible={isVisibleSidebar || !!chosen}
        onClose={handleClose}
        width={584}
        title={<Header onPress={handleClose} />}
        customPadding={32}
        footer={
          <Footer
            loading={loading}
            onPress={() => {
              setLoading(true)
              addInvoicesToProject(projectId, handleSuccess)
            }}
            onPressCancel={() => {
              updateSelectedInvoices({ selectedRows: [] })
              setVisibleSidebar()
              setVisibleEdit(false)
              setLoading(false)
              setChosen(null)
              return null
            }}
            isValidData={false}
          />
        }
      >
        <View style={{ paddingHorizontal: 20 }}>
          <BtText style={styles.addToProjectText}>
            {t('Projects.selectAddToProject')}
          </BtText>

          <ProjectAddRemoveTable />
        </View>
      </BtSidebar>
    )
  },
)
